import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);

const LS_LANG = "zr_lang";

export function ContentProvider({ children }) {
    const [content, setContent] = useState(null);
    const [lang, setLangState] = useState(() => localStorage.getItem(LS_LANG) || "ca");
    const [loading, setLoading] = useState(true);

    const setLang = (l) => {
        localStorage.setItem(LS_LANG, l);
        setLangState(l);
    };

    const fetchContent = useCallback(async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data);
        } catch (e) {
            console.error("Failed to load content", e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchContent();
    }, [fetchContent]);

    const t = content?.translations?.[lang] || content?.translations?.ca || {};

    return (
        <ContentContext.Provider value={{ content, setContent, lang, setLang, t, loading, refetch: fetchContent }}>
            {children}
        </ContentContext.Provider>
    );
}

export const useContent = () => {
    const ctx = useContext(ContentContext);
    if (!ctx) throw new Error("useContent must be used inside ContentProvider");
    return ctx;
};
